import React, { useContext, useRef } from "react";
import {
  Footer,
  Navigation,
  Header,
  Dialog,
  HCPOnly,
  PatientRedirect,
} from "../../components";
import { LocalContext } from "../../context";
import { GlobalStyle } from "../../styles";

const Layout = ({ location, children }) => {
  const {
    showHCPOnlyDialog,
    setShowHCPOnlyDialog,
    showPatientSiteDialog,
    setShowPatientSiteDialog,
  } = useContext(LocalContext);

  const hcpOnlyDialogRef = useRef(null);
  const patientSiteDialogRef = useRef(null);

  const closeHCPOnlyDialog = () => {
    hcpOnlyDialogRef.current.setAttribute("data-state", "close");
    hcpOnlyDialogRef.current.children[0].setAttribute("data-state", "close");
    setShowHCPOnlyDialog(false);
  };

  const closePatientSiteDialog = () => {
    patientSiteDialogRef.current.setAttribute("data-state", "close");
    patientSiteDialogRef.current.children[0].setAttribute("data-state", "close");
    setShowPatientSiteDialog(false);
  };

  return (
    <>
      <GlobalStyle />
      <Navigation />
      <Header location={location} />
      {children}
      <Footer />
      <Dialog large ref={hcpOnlyDialogRef} isVisible={showHCPOnlyDialog}>
        <HCPOnly onDismiss={closeHCPOnlyDialog} setShowPatientSiteDialog={setShowPatientSiteDialog} />
      </Dialog>
      <Dialog
        large
        ref={patientSiteDialogRef}
        isVisible={showPatientSiteDialog}
        onDismiss={closePatientSiteDialog}
        showCloseButton={true}
      >
        <PatientRedirect />
      </Dialog>
    </>
  );
};

export default Layout;
